export const newRow = (approvalConfigNumber) => ({
    subType: '',
    approvalConfigNumber,
    isLoanComponent: '',
    amount: '',
    roleApprovals: {
        LEVEL_1: [],
        LEVEL_2: [],
        LEVEL_3: []
    },
    status: 'ACTIVE'
})